module.exports = __webpack_public_path__ + "img/video-slide-1.ff2ac5fd.jpg";